import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-column gap-3" };
import { computed, inject } from "vue";
import { storeToRefs } from "pinia";
// Composable
import { useConversationResponse } from "../composables/useConversationPolling";
// Components
import Summary from "../components/SummaryBlock.vue";
import Transcript from "../components/TranscriptBlock.vue";
// Stores
import { useContext } from "@/store/context";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConversationView',
    props: {
        showSummary: { type: Boolean },
        showSummaryAccordion: { type: Boolean },
        showTranscript: { type: Boolean },
        showTranscriptAccordion: { type: Boolean },
        compact: { type: Boolean },
        excerptable: { type: Boolean },
        response: {},
        studyName: {},
        activityName: {},
        taskName: {},
        taskIndex: {},
        taskCount: {},
        fullName: {},
        firstName: {},
        username: {},
        userId: {},
        responseId: {},
        responseUrl: {}
    },
    setup(__props) {
        const i18n = inject("i18n");
        const props = __props;
        const { isUnrestricted, isSuperAdmin } = storeToRefs(useContext());
        // Use composable for reactive response with automatic polling
        const { response: currentResponse, regenerateSummary } = useConversationResponse(props.response);
        // Computed clipboard header for copy operations
        const clipboardHeader = computed(() => {
            const lines = [];
            console.log("Study Name:", props.studyName);
            if (props.studyName) {
                lines.push(`${i18n.t("Study")}: ${props.studyName}`);
            }
            if (props.activityName) {
                lines.push(`${i18n.t("Activity")}: ${props.activityName}`);
            }
            if (props.taskName) {
                lines.push(`${i18n.t("Task")} ${props.taskIndex}/${props.taskCount}: ${props.taskName}`);
            }
            if (props.fullName || props.username || props.userId) {
                const participant = `${props.fullName || ""} ${props.username ? "@" + props.username : ""} ${props.userId ? "#" + props.userId : ""}`.trim();
                lines.push(`${i18n.t("Participant")}: ${participant}`);
            }
            if (props.responseId) {
                lines.push(`${i18n.t("Response Reference")}: #TR${props.responseId}`);
            }
            if (props.responseUrl) {
                lines.push(props.responseUrl);
            }
            console.log("clipboardHeader lines:", lines);
            return lines.length > 0 ? lines.join("\n") + "\n\n" : "";
        });
        const canRegenerateSummary = computed(() => {
            return isSuperAdmin.value && isUnrestricted.value;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (props.showSummary)
                    ? (_openBlock(), _createBlock(Summary, {
                        key: 0,
                        excerptable: _ctx.excerptable,
                        response: _unref(currentResponse),
                        "wrap-in-accordion": props.showSummaryAccordion,
                        "clipboard-header": clipboardHeader.value,
                        "can-regenerate": canRegenerateSummary.value,
                        onRegenerate: _unref(regenerateSummary)
                    }, null, 8, ["excerptable", "response", "wrap-in-accordion", "clipboard-header", "can-regenerate", "onRegenerate"]))
                    : _createCommentVNode("", true),
                (props.showTranscript)
                    ? (_openBlock(), _createBlock(Transcript, {
                        key: 1,
                        excerptable: _ctx.excerptable,
                        response: _unref(currentResponse),
                        "wrap-in-accordion": props.showTranscriptAccordion,
                        "clipboard-header": clipboardHeader.value,
                        "user-name": props.firstName || props.username || 'User'
                    }, null, 8, ["excerptable", "response", "wrap-in-accordion", "clipboard-header", "user-name"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
